@import '../../styles/shared/status.css';

.eds-status-badge {
  --eds-status-badge--height: calc(
    var(--eds--typography--body-semi-s-line-height) + var(--eds--padding-2) +
      var(--eds--padding-4)
  );
  align-items: center;
  border-radius: var(--eds--radii-full);
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  max-width: 240px;
  min-height: var(--eds-status-badge--height);
  min-width: 0;
  overflow: hidden;
  padding: var(--eds--padding-2) var(--eds--padding-12) var(--eds--padding-4);
  width: fit-content;
}

.eds-status-badge .eds-tooltip--trigger {
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  width: 100%;
}

.eds-status-badge--loading {
  height: var(--eds-status-badge--height);
  padding: 0;
  width: var(--eds--size-64);
}
